import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import CustomMap from "../../Components/Map";
import CardButton from "../../Components/Buttons/card-button";
import PrimaryButton from "../../Components/Buttons/primary-button";
import useFidel from "../../CustomHooks/useFidel";
import { useGetFidelCards } from "../../CustomHooks/Queries";
import { ArrowLeftCircle, Card, Coupon, Purse, SquareArrowOptUpRight } from "../../Assets/Icons";
import "./neighborhood-network.scss";
import "./neighborhood-network-responsive.scss";
import { getUserId } from "../../Utils/helpers";

function NeighborhoodNetwork() {
  const navigate = useNavigate();

  const { isLoadingFidel, linkingCard, LinkCard } = useFidel();

  const { isLoading: isLoadingFidelCards, data: fidelCards } = useGetFidelCards();

  const atleastOneFidelCardLinked = fidelCards?.length > 0;

  const navigateToOfferNearYou = () => {
    if (atleastOneFidelCardLinked) navigate("/deals/neighborhood-network/offers-near-you");
    else LinkCard();
  };

  const isLoading = isLoadingFidelCards || isLoadingFidel;
  const residentId = getUserId();


  return (
    <div className="neighborhood-network main">
      <section className="card-section-wrapper">
        <div className="max-width-container">
          <div className="card-section">
            <div className="section-header">
              <button className="go-back-button" onClick={() => navigate(-1)}>
                <ArrowLeftCircle />
              </button>
              <h3 className="section-title">Neighborhood Network</h3>
              <div className="dummy"></div>
            </div>
            {isLoading ? (
              <div className="loading-content">
                <CircularProgress />
              </div>
            ) : (
              <div className="content">
                <div className="top-container d-flex flex-column flex-grow-1">
                  <div className="text-xl-semibold color--mist">
                    Browse merchants{atleastOneFidelCardLinked && " near you"}
                  </div>
                  {atleastOneFidelCardLinked && (
                    <button
                      className="d-flex align-items-center gap-1 text-base-regular color--american-silver mt-1"
                      onClick={navigateToOfferNearYou}
                    >
                      Tap to find offers near you <SquareArrowOptUpRight />
                    </button>
                  )}
                  <CustomMap onMapClick={navigateToOfferNearYou} residentId={residentId} />
                  {atleastOneFidelCardLinked ? (
                    <>
                      <CardButton
                        className="mt-6"
                        title="My Cards"
                        description="Link your credit or debit cards securely."
                        Icon={Card}
                        onClick={navigate.bind(this, "/deals/neighborhood-network/linked-cards")}
                      />
                      <CardButton
                        className="mt-5"
                        title="Brands & Offers"
                        description="Find deals and earn rewards effortlessly."
                        Icon={Coupon}
                        onClick={navigate.bind(this, "/deals/neighborhood-network/brands-and-offers")}
                      />
                      <CardButton
                        className="mt-5"
                        title="Neighborhood Cash"
                        description="See how much you’ve earned so far."
                        Icon={Purse}
                        onClick={navigate.bind(this, "/deals/neighborhood-network/rewards")}
                      />
                    </>
                  ) : (
                    <>
                      <div className="text-xl-semibold color--mist mt-4 mb-2">How it works?</div>
                      <p className="text-base-regular color--mist mb-3">
                        The My Cards page allows you to link your credit and debit cards to your Stake account.<br></br>
                        When you use any of the linked cards to make a Qualifying Purchase from participating Stake
                        merchants, you get cash back.
                      </p>
                      <p className="text-base-regular color--mist mb-3">
                        Not all transactions made with your inked cards (including PIN-based transactions, payment
                        through a third-party digital wallet or payment app) can be monitored for eligibility as a
                        Qualifying Purchase. When using a debit card, always select "credit" and do not use a PIN to
                        ensure the transaction is eligible as a Qualifying Purchase.
                      </p>
                      <p className="text-base-regular color--mist mb-0">
                        Please see the app{" "}
                        <a
                          className="color--primary-400"
                          href="https://www.stakerent.com/legal/terms-of-use"
                          target="_blank"
                          rel="noreferrer"
                        >
                          Terms of Use
                        </a>{" "}
                        for more details on card eligibility and Qualifying Purchases.
                      </p>{" "}
                    </>
                  )}
                </div>
                {!atleastOneFidelCardLinked && (
                  <div className="bottom-container">
                    <PrimaryButton onClick={LinkCard} disabled={linkingCard}>
                      Link Credit or Debit Card{linkingCard && <CircularProgress />}
                    </PrimaryButton>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default NeighborhoodNetwork;
